import React from 'react';
import {Button, Container} from 'react-bootstrap';
import {useClarity} from '../hooks/useClarity';

const CTASection = () => {
    const {trackBookingClick} = useClarity();

    return (
        <section className="final-cta-section">
            <Container>
                <h2>Ready to see it work on a problem that matters?</h2>
                <p className="cta-description">
                    Book a call where we'll identify one decision your team makes repeatedly
                    where the current AI tooling falls short - and if it's the right fit,
                    we'll have a working pilot in 3–4 weeks.
                </p>
                <div className="d-flex gap-3 justify-content-center flex-wrap">
                    <Button
                        size="lg"
                        className="cta-button-light"
                        href="https://cal.eu/jon-cooke/discovery-call"
                        onClick={() => trackBookingClick('final-cta')}>
                        Book your discovery call
                    </Button>
                </div>
                <div className="cta-proof-strip mt-4">
                    <span>✓ Patent pending</span>
                    <span>✓ Currently deployed in UK financial services</span>
                    <span>✓ 3–4 week pilot</span>
                    <span>✓ UK data sovereignty</span>
                </div>
            </Container>
        </section>
    );
};

export default CTASection;